var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"award_wrap"},[_c('div',{staticClass:"al_default_wrap"},[_c('div',{staticClass:"award_title"},[_vm._v(_vm._s(_vm.$t('award')))])]),_c('award-list-component',{attrs:{"award-type":'award',"award-key":_vm.awardKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }